import styled, { css } from 'styled-components';

import { colors } from 'global/colors';
import { lightModeHeaderBackground } from 'global/themeLight';

const headerBreakPoint = '720px';

const SectionMarginBottom = '100px';
const innerMarginBottom = '50px';

const borderRadius = '24px';

export const SectionBackground = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ topColor, bottomColor, bgColor, theme }) =>
    topColor || bottomColor
      ? css`
          background: linear-gradient(
            to bottom,
            ${topColor || bgColor || theme.pageBackground} 0%,
            ${topColor || bgColor || theme.pageBackground} 50%,
            ${bottomColor || bgColor || theme.pageBackground} 50%,
            ${bottomColor || bgColor || theme.pageBackground} 100%
          );
        `
      : bgColor &&
        css`
          background: ${bgColor};
        `}
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  margin-top: 50px;
`;

export const HeaderContent = styled.div`
  width: 50%;
  z-index: 1;
  @media (max-width: ${headerBreakPoint}) {
    width: 100%;
  }
`;

export const FatText = styled.span`
  font-weight: 600;
`;

export const HeaderText = styled.h2`
  color: ${({ theme }) => theme.title};
  margin-top: ${innerMarginBottom};
  margin-bottom: 25px;

  ${({ small }) => css`
    font-size: ${small ? '2.625rem' : '3.5rem'};
  `}

  @media (max-width: ${headerBreakPoint}) {
    font-size: min(12vw, 1.5rem);
  }
`;
export const Title = styled.h2`
  color: ${({ theme }) => theme.title};
  margin-bottom: ${innerMarginBottom};
  margin-top: ${innerMarginBottom};
  font-size: 2.625rem;

  @media (max-width: ${headerBreakPoint}) {
    font-size: min(12vw, 1.5rem);
  }
`;

export const Paragraph = styled.p`
  ${({ textColor, theme }) => css`
    color: ${textColor || theme.text};
  `}
  font-size: 1.5rem;
  margin-bottom: ${innerMarginBottom};
  @media (max-width: ${headerBreakPoint}) {
    // font-size: 1.2rem;
  }
`;

export const LaptopWrapper = styled.div`
  margin-top: ${innerMarginBottom};
  margin-bottom: -${innerMarginBottom};
`;

export const LaptopContainer = styled.div`
  position: relative;
  width: 874px;
  max-width: 100vw;
  height: 516px;
  max-height: 59.039vw;
  margin-bottom: 4rem;
`;

export const LaptopIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 5.45% 13.32% 7.65% 13.53%;
`;

export const LaptopImage = styled.img`
  position: absolute;
  max-width: 100%;
`;

export const MarketingPointsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 2rem;
  column-gap: 8rem;
  margin-bottom: ${SectionMarginBottom};
`;

export const MarketingPointContainer = styled.div`
  color: ${({ theme }) => theme.text};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 18rem;
  gap: 20px;
`;

export const MarketingPointImage = styled.img`
  width: 75%;
`;

export const MarketingPointText = styled.p`
  color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.title : theme.text)};
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
  min-height: 72px;
`;

export const MarketingPointParagraph = styled.p`
  font-size: 1.125rem;
  text-align: center;
`;

export const LanguageBox = styled.a`
  display: block;
  z-index: 1;
  width: 220px;
  height: 220px;
  background: ${({ isDarkMode, theme }) => (isDarkMode ? theme.pageBackground : lightModeHeaderBackground)};
  border: 6px solid ${({ isDarkMode }) => (isDarkMode ? colors.darkGray5 : colors.lightGray3)};
  border-radius: ${borderRadius};
  text-align: center;
  margin: auto;
  & i {
    font-size: 4rem;
  }
  &:hover {
    text-decoration: none;
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
`;

export const LanguageBoxIconContainer = styled.div`
  height: 160px;
  line-height: 200px;
`;

export const LanguageButton = styled.div`
  appearance: button;
  background: ${({ isDarkMode, theme }) => (isDarkMode ? colors.darkGray5 : theme.pageBackground)};
  color: ${({ theme }) => theme.text};
  border-radius: 8px;
  margin: 0 15px;
  padding: 0.375rem 1rem;
  letter-spacing: 1px;
`;

export const LoginBox = styled.section`
  display: flex;
  justify-content: center;
  padding: 4rem 2rem;
  border-radius: ${borderRadius};
  background-color: ${colors.lightBlue8};
  margin-top: 6rem;
  margin-bottom: 2rem;
  @media (max-width: ${headerBreakPoint}) {
    flex-direction: column;
  }
`;

export const LoginBoxContent = styled.div`
  flex: 1 1 65%;
  padding: 2rem;
  @media (max-width: ${headerBreakPoint}) {
    flex: 1 1 100%;
    padding: 2rem 0;
  }
`;

export const Link = styled.a`
  letter-spacing: 1px;
  font-size: 1.125rem;
  font-weight: 600;
  color: ${colors.white};
  margin-right: 20px;

  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      padding: 0.725rem 2rem;
      border: 1px solid ${colors.white};
      border-radius: 0.25rem;
    `}

  :hover {
    color: ${colors.lightGray6};
    border-color: ${colors.lightGray6};
    text-decoration: none;
  }
`;

export const SectionContentContainer = styled.div`
  flex: 1 1 50%;
  & img {
    max-width: 100%;
  }

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}

  @media (max-width: ${headerBreakPoint}) {
    flex: 1 1 100%;
    ${({ first }) =>
      first &&
      css`
        order: -1;
      `}
  }
`;

export const CodingCharactersGIF = styled.img`
  border-radius: ${borderRadius};
  margin-top: -150px;
`;

export const FunForAllImagesContainer = styled.div`
  flex: 1 1 50%;
  & img {
    max-width: 100%;
  }

  @media (max-width: ${headerBreakPoint}) {
    flex: 1 1 100%;
    text-align: center;
  }
`;

export const FunForAllLink = styled.a`
  @media (max-width: ${headerBreakPoint}) {
    width: 100%;
    text-align: center;
  }
`;

export const FunForAllGIF = styled.img`
  border-radius: ${borderRadius};
  margin-top: -200px;
  margin-bottom: -75px;
  position: relative;
  z-index: 1;
  @media (max-width: ${headerBreakPoint}) {
    margin-top: -100px;
    margin-bottom: 0;
  }
`;

export const FunForAllImage = styled.img`
  padding-top: 2rem;
  position: relative;
  z-index: 2;
  pointer-events: none;
`;

export const LearnFromPeersImage = styled.img`
  margin-top: -70px;
  @media (max-width: ${headerBreakPoint}) {
    margin-top: 0;
  }
`;

export const CanvasContainer = styled.div`
  position: absolute;
  margin-top: 80px;
  width: 100vw;
  height: 100%;
  max-width: 1200px;

  @media (max-width: ${headerBreakPoint}) {
    position: relative;
    margin-bottom: -130px;
  }
`;
